exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text[data-v-15130fa0] {\n  font-size: 40px;\n  color: red;\n  font-weight: bold;\n  text-align: center;\n  font-family: Cambria, Cochin, Georgia, Times, \"Times New Roman\", serif;\n}\n.picture[data-v-15130fa0] {\n  display: block;\n  margin: 0 auto;\n  width: 700px;\n  height: 550px;\n}\n", ""]);

// exports
